module.exports = __webpack_public_path__ + "static/media/screen-individual-01.6462485e.jpg";